<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <h4 style="border-bottom: 1px solid gray;" v-if="dispose == 1">Dispose Form</h4>
      <h4 style="border-bottom: 1px solid gray;" v-if="dispose == 0">Revert Form</h4>
      <div class="form-group" v-if="dispose == 1">
        <label for="remarks">Dispose Type :</label>
         <select class="form-control" v-model="disposetype">
          <option value="">Select</option>
          <option :value="1">Sale</option>
          <option :value="2">Fake</option>
         </select>
      </div>
      <div class="form-group" >
        <label for="remarks">Date :</label>
        <input type="date" v-model="disposedate" class="form-control" />
      </div>
      <div class="form-group">
        <label for="remarks">Remarks:</label>
        <textarea id="remarks" v-model="remarks" class="form-control"></textarea>
      </div>
      <div class="modal-actions">
        <button @click="submit" class="btn btn-primary">Submit</button>
        <button @click="close" class="btn btn-secondary">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['editproperty', 'dispose'],

  data() {
    return {
      date: '',
      remarks: '',
      disposedate: '',
      disposetype:''
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      if(this.disposetype=='' && this.dispose==1){
        alert('Please select dospose type.')
      }
      if (this.disposedate == '') {
        alert('Please select a date');
        return;
      }
      if (this.remarks == '') {
        alert('Please enter remarks');
        return;
      }
      if (confirm('Are you sure you want to proceed?')) {
        const param = {
          id: this.editproperty.id,
          disposeremark: this.remarks,
          isdisposed: this.dispose,
          disposedate: this.disposedate,
          disposetype: this.disposetype,
        };

        axios.post('api/realestate/status/update', param)
          .then(response => {
            console.log(response.data);
            this.$parent.refresh()
            alert('Property status updated successfully');
            this.$emit('close');
          })
          .catch(error => {
            console.error('Error setting :', error);
          });
      }
    },
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;

}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>